// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"c716b3e2","213":"25379794","483":"3e5f3847","549":"9a19e4a4","634":"6785b6b4","766":"9ee86862"}[chunkId] + ".chunk.js";
};